<!-- 
    * 切换图层服务 出现位置：屏幕正中间
    * 可以切换百度、高德和必应图层，并对应不同图层的各种显示效果的选择
 -->
<template>
    <transition  
        name="animate__animated animate__bounce" 
        enter-active-class="animate__pulse" 
        leave-active-class="animate__fadeOutDown"> 
        <div class="toolContainer"   v-show="isShowMapProvider">   
          <div class="demo-toolbar">
              <a class="popup-close-button" @click="showMapProvider">x</a>
              <el-col>
                <div class="block">
                    <span class="demonstration" >切换图层服务</span><hr>
                    <!-- style="margin-bottom: 10px;" -->
                    <el-select v-model="currentMap" placeholder="请选择" style="margin-bottom: 10px;">
                      <el-option v-for="item in mapArray" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                    <el-select v-model="mapStyle" placeholder="请选择"  >
                      <el-option v-for="item in mapStyleOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
              </el-col>
          </div>
        </div> 
    </transition>  
</template>

<script>
export default {
    name:'MapProviderDialog',
    data(){
        return {
          isShowMapProvider:false,
          currentMap:'高德地图',
          mapArray: [             
              {id:'baidu01',value:'百度地图'},
              {id:'amap01',value:'高德地图'},
              {id:'bing01',value:'必应地图'}
          ],
          mapStyle: '7',
          isMapStyle: true,
          mapStyleOptions:[]
        }
    },
    methods:{
        showMapProvider(){
          console.log('MapProviderDialog 组件,显示');
          this.isShowMapProvider = !this.isShowMapProvider ;
        }, 
        getMapOptions(mapOptions){
            console.log("获取地图选项：",mapOptions);
            this.mapStyleOptions = mapOptions ;
            // this.mapStyle = mapOptions[0].value ;
            console.log("@@@@@",this.mapStyleOptions);
        },
    },
    watch:{
      mapStyle:{
        immediate:true,
        handler(newVal){
          // console.log('MapProviderDialog 组件,mapStyle = ',this.mapStyle)
          this.$bus.emit('getMapStyle',newVal);
        }
      },
      currentMap:{
        handler(){
          // debugger
          // console.log('MapProviderDialog 组件,currentMap = ',this.currentMap);
          this.$bus.emit('getCurrentMap',this.currentMap);
        }
      }
    },
    mounted(){
      this.$bus.on('getMapOptions',this.getMapOptions);
      this.$bus.on('showMapProvider',this.showMapProvider);
    },
    beforeUnmount() {
        this.$bus.off('getMapOptions');
        this.$bus.off('showMapProvider');
    },
}
</script>

<style scoped>
.demo-toolbar {
    position: absolute;

    /* transform: translate(-50%,-50%); */
    /* min-width: 185px;
    z-index: 100; */
    color: #fff;
    background-color: rgba(0,0,0,.9);
    border-radius: 5px;
}
/* 
.demo-vc-viewer .el-switch:first-child {
    margin-left: 20px;
}

.demo-vc-viewer .el-switch {
    margin: 20px 20px 20px 0;
}

.demo-vc-datasource-custom {
  .el-switch__label.is-active {
    color: #409eff;
  }
} */

.block {
  padding: 30px 24px;
  overflow: hidden;
  /* border-bottom: solid 1px #eff2f6; */
/* 
  &:last-child {
    border-bottom: none;
  } */
}

/* .el-row {
    border-radius: 100px;
    align-items: baseline;

    &:last-child {
      margin-bottom: 0;
    }
  } */
  /* .el-button {
    margin: 10px 10px 10px 0;

    &:first-child {
      margin-left: 20px;
    }
  } */

  .el-switch {
    margin: 20px 20px 20px 0;

    &:first-child {
      margin-left: 20px;
    }
  }

  .el-switch__label {
    color: white;
  }


  .toolContainer{
      position: absolute;
      left: 40%;
      top: 30%;
      min-width: 185px;
      z-index: 100;
      width: 296px;
      height: 180px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      box-shadow: 16px 14px 20px #0000008c;
  }

  .toolContainer::before{
      content: '';
      background-image: conic-gradient(#525d67 20deg, transparent 120deg);
      width: 200%;
      height: 200%;
      position: absolute;
      animation: border 3s linear infinite;
  }

  @keyframes border{
      0%{ transform: rotate(0deg); }
      100%{   transform: rotate(-360deg);}
  }
  .popup-close-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px 10px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 9999;
  }

  .popup-close-button:hover {
    cursor: pointer;
    color: red;
  }
</style>